<template>
  <div class="onlineCheckPage">
    <div class="wrapperInfo">
      <Form>
        <FormItem :label-col="firstLabel" :wrapper-col="firstWrapper">
          <Button type="primary" style="margin-left:110px;" @click="infoFromMachine">获取读卡器信息</Button>
        </FormItem>
        <FormItem label="身份证号" :label-col="labelCol" :wrapper-col="wrapperCol">
          <Input placeholder="请输入身份证号" v-model="patientIdNum">
            <Button slot="suffix" type="primary" @click="infoFromLibrary">读取</Button>
          </Input>
        </FormItem>
        <FormItem label="姓名" :label-col="labelCol" :wrapper-col="wrapperCol">
          <span>{{patientName}}</span>
        </FormItem>
        <FormItem label="生日" :label-col="labelCol" :wrapper-col="wrapperCol">
          <span>{{birthday}}</span>
        </FormItem>
        <FormItem label="性别" :label-col="labelCol" :wrapper-col="wrapperCol">
          <span>{{patientSex}}</span>
        </FormItem>
      </Form>
    </div>
    <div class="buttonWrap">
      <div class="endButton">
        <Button size="large" @click="removeOnlineModal">取消</Button>
        <Button type="primary" size="large" @click="handleMakeCode">生成二维码</Button>
      </div>
    </div>
    <!-- 无身份证填写 -->
    <Modal title="提示" v-model="warningModal" v-if="warningModal" @ok="handleNoInfo" cancelText="返回">
      <p>是否确认生成无身份证信息的二维码？</p>
      <p>注：患者通过此二维码线上注册时，需要手工填写所有个人信息</p>
    </Modal>
  </div>
</template>

<script>
import { Button, Form, Input, Modal } from 'ant-design-vue'
import { switchTimeFormat, toast } from '../../libs/utils'
import { get_info_from_id_card } from '../../libs/idCard'
import { readIdCardNo } from '../../api/user'
import { getPatientInfoByIdNumber } from '../../api/check'
import { onlineCheckinMakeCode } from '../../api/onlineCheckin'
export default {
  props: {
    currentCenterId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Button,
    Form,
    FormItem: Form.Item,
    Input,
    Modal
  },
  data () {
    return {
      firstLabel: {
        md: {span: 10}, lg: { span: 10 }, xl: { span: 10 }, xxl: { span: 10 }, xs: {span: 10}
      },
      firstWrapper: {
        md: {span: 10}, lg: { span: 10 }, xl: { span: 10 }, xxl: { span: 10 }, xs: {span: 10}
      },
      labelCol: {
        md: {span: 3}, lg: { span: 2 }, xl: { span: 6 }, xxl: { span: 4 }, xs: {span: 4}
      },
      wrapperCol: {
        md: {span: 10}, lg: { span: 10 }, xl: { span: 10 }, xxl: { span: 10 }, xs: {span: 10}
      },
      patientIdNum: '',
      patientName: '',
      birthday: '',
      patientSex: '',
      warningModal: false
    }
  },
  methods: {
    // 从读卡器获取信息
    async infoFromMachine () {
      if (this.patientIdNum.length === 0) {
        let readPatient = await readIdCardNo()
        if (readPatient && readPatient.cardno) {
          this.patientIdNum = readPatient.cardno
          this.patientName = readPatient.name
          this.photobase64 = readPatient.photobase64
          let patientInfo = get_info_from_id_card(this.patientIdNum)
          this.patientSex = patientInfo.sex == 1 ? '男' : '女'
          this.birthday = switchTimeFormat(patientInfo.birthday, 1)
        }
      }
    },
    // 从数据库中读取信息 
    async infoFromLibrary () {
      if (!this.patientIdNum) return toast({ title: '提示', type: 'warning', msg: '请填写患者身份证' })
      let patientInfo = get_info_from_id_card(this.patientIdNum)
      if (!patientInfo.status) return toast({msg: patientInfo.msg})
      let data = await getPatientInfoByIdNumber({ idNumber: this.patientIdNum})
      this.patientName = data.real_name || ''
      this.patientSex = patientInfo.sex == 1 ? '男' : '女'
      this.birthday = switchTimeFormat(patientInfo.birthday, 1)
    },
    removeOnlineModal () {
      this.$emit('removeOnlineModal')
    },
    async handleMakeCode () {
      if (!this.patientIdNum) return toast({ title: '提示', type: 'warning', msg: '请填写患者身份证' })
      if (!this.birthday) return toast({ title: '提示', type: 'warning', msg: '请点击查询' })
      let params = {
        birthDate: this.birthday,
        customerChannel: 'BJ_TYXL',
        gender: this.patientSex,
        idNumber: this.patientIdNum,
        real_name: this.patientName
      }
      if (this.photobase64) params.imageBase64 = this.photobase64
      if (this.currentCenterId) params.imageCenterId = this.currentCenterId
      let data = await onlineCheckinMakeCode(params)
      if (data) {
        return toast({ title: '提示', type: 'success', msg: '生成二维码成功' })
      }
    },
    handleNoInfo () {
      this.warningModal = false
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.onlineCheckPage{
  .wrapperInfo{
    .ant-input-suffix {
      right: 0;
    }
    .ant-form-item{
      margin-bottom: 0;
    }
  }
  .buttonWrap{
    .modalFooter();
  }
}
</style>